/**
 * Conteneur principal du contenu des pages
 *
 * Rôle : Applique la marge et le padding (pt-24) à toutes les pages sauf signin/signup.
 * Évite le décalage sous le header fixe sur les pages authentifiées.
 * Technologies : Next.js (usePathname), React
 */
"use client";

import { usePathname } from "next/navigation";

export default function DynamicMain({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  
  // Pas de padding-top sur les pages d'authentification
  const isAuthPage = pathname === "/signin" || pathname === "/signup";
  
  return (
    <main className={`mx-auto max-w-6xl px-6 py-8 ${isAuthPage ? "" : "pt-24"}`}>
      {children}
    </main>
  );
}
